import { SUBMIT_CHECKOUT_REQUEST } from 'redux/actions';
import { arrayContains } from 'utils';

export const isSubmitCheckoutLoading = (state) => arrayContains(state.payment.openRequests, [SUBMIT_CHECKOUT_REQUEST]);
